import { logClickEvent, logDebugCacheEvent, } from '@office-start/instrumentation-service';
import { mark } from '@office-start/performance-service';
import { logDiagnostic, logError, logFeature, logReferUserAction, } from '@office-start/telemetry-service';
import { getFeatureNameFromArea, getOtelParamsFromInstrumentationParams, getReferral, } from '@office-start/telemetry-utility';
export var logClick = function (logClickParams) {
    var _a;
    var launchInstrumentationParams = logClickParams.launchInstrumentationParams, success = logClickParams.success, platform = logClickParams.platform, uiHost = logClickParams.uiHost;
    if (!launchInstrumentationParams) {
        return;
    }
    var area = launchInstrumentationParams.area, isLogged = launchInstrumentationParams.isLogged, dataSecurityLevel = launchInstrumentationParams.dataSecurityLevel, eventName = launchInstrumentationParams.eventName, elementId = launchInstrumentationParams.elementId, renderTimingInstrumentationParams = launchInstrumentationParams.renderTimingInstrumentationParams, referral = launchInstrumentationParams.referral;
    var clickParams = launchInstrumentationParams.clickParams;
    if (isLogged) {
        return;
    }
    launchInstrumentationParams.isLogged = true;
    if (!clickParams) {
        clickParams = {};
    }
    clickParams["ClickDestination" /* InstrumentationParam.ClickDestination */] = uiHost
        ? "ContentPage" /* KnownClickDestinations.ContentPage */
        : "ExternalPage" /* KnownClickDestinations.ExternalPage */;
    logClickEvent(eventName, elementId, area, success ? referral : '', platform, clickParams, [], dataSecurityLevel);
    // TODO: Remove above Aria logging after fully migrating to OTEL
    if (success) {
        logReferUserAction(elementId, area, referral, undefined, undefined, eventName);
        logFeature({
            featureName: getFeatureNameFromArea(area),
            eventName: eventName,
            params: getOtelParamsFromInstrumentationParams(clickParams),
            area: area,
        });
    }
    else {
        var referralTarget = referral ? getReferral(referral) : 'Other';
        var debugInfo = "Error: \nelementId: ".concat(elementId, "\n referral: ").concat(referralTarget, "}");
        var params = (_a = {},
            _a["DebugInfo" /* InstrumentationParam.DebugInfo */] = debugInfo,
            _a);
        logError({
            eventName: eventName,
            debugInfo: debugInfo,
        });
        logDiagnostic({
            eventName: eventName,
            params: params,
            area: area,
        });
        // TODO: Remove when Otel is enabled
        logDebugCacheEvent(eventName, params, [], dataSecurityLevel);
    }
    // If this is first item click since MRU paint, also log perf marker for time elapsed between the 2 events.
    if (renderTimingInstrumentationParams) {
        var clickMarker = renderTimingInstrumentationParams.clickMarker, paintMarker = renderTimingInstrumentationParams.paintMarker;
        mark(clickMarker, paintMarker);
    }
};
//# sourceMappingURL=logClick.js.map